module.exports = __webpack_public_path__ + "img/symbol_5.653b0d5b.png";